// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Receipt21Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Receipt21/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.15 1.667h-6.3c-3.15 0-3.933.841-3.933 4.2v9.383c0 2.217 1.216 2.742 2.691 1.158l.009-.008c.683-.725 1.725-.667 2.316.125l.842 1.125c.675.892 1.767.892 2.442 0l.841-1.125c.6-.8 1.642-.858 2.325-.125 1.484 1.583 2.692 1.058 2.692-1.158V5.867c.008-3.359-.775-4.2-3.925-4.2ZM6.483 10a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834.459 0 .834.375.834.834a.836.836 0 0 1-.834.833Zm0-3.333a.836.836 0 0 1-.833-.834c0-.458.375-.833.833-.833.459 0 .834.375.834.833a.836.836 0 0 1-.834.834Zm7.042 3.125H8.942a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.583a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Zm0-3.334H8.942a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.583a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default Receipt21Icon;